function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignStopEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stop_x5F_EU",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B33229"
    },
    points: "90,30.603 65.397,6 30.603,6 6,30.603 6,65.397 30.603,90 65.397,90 90,65.397  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M64.569,8L88,31.431v33.137L64.569,88H31.431L8,64.569V31.431L31.431,8H64.569 M65.397,6H30.603 L6,30.603v34.794L30.603,90h34.794L90,65.397V30.603L65.397,6L65.397,6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M29.932,40.726h-4.59v-1.035c0-2.115-0.9-3.87-3.24-3.87c-2.52,0-3.105,2.025-3.105,4.14 c0,2.475,0.225,3.33,2.61,4.275l3.51,1.395c4.05,1.53,4.815,4.095,4.815,8.774c0,5.4-1.98,9.404-7.919,9.404 c-4.455,0-7.83-3.284-7.83-7.604v-1.71h4.59v1.439c0,1.665,0.9,3.285,3.24,3.285c3.104,0,3.33-1.845,3.33-4.771 c0-3.419-0.405-3.959-2.655-4.859l-3.285-1.35c-3.959-1.62-4.995-4.23-4.995-8.235c0-4.86,2.61-8.774,7.875-8.774 c4.59,0,7.65,3.69,7.65,7.245V40.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M36.367,35.821h-5.31v-4.32h15.209v4.32h-5.31V63.54h-4.59V35.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M47.482,39.061c0-5.22,3.96-7.83,7.694-7.83c3.735,0,7.694,2.61,7.694,7.83V55.98 c0,5.22-3.959,7.829-7.694,7.829c-3.734,0-7.694-2.609-7.694-7.829V39.061z M52.072,55.98c0,2.205,1.439,3.24,3.104,3.24 s3.105-1.035,3.105-3.24V39.061c0-2.205-1.44-3.24-3.105-3.24s-3.104,1.035-3.104,3.24V55.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M66.922,31.501h6.885c2.52,0,4.364,0.585,5.939,2.25c1.575,1.665,2.07,3.689,2.07,7.515 c0,2.79-0.226,4.68-1.306,6.435c-1.26,2.07-3.284,3.331-6.659,3.331h-2.34V63.54h-4.59V31.501z M71.512,46.711h2.205 c3.734,0,3.779-2.205,3.779-5.4c0-3.015,0-5.49-3.6-5.49h-2.385V46.711z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignStopEu);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_stop_eu.f2d9bee51814ff6439e043f943e04210.svg";
export { ForwardRef as ReactComponent };